import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { CommonStyles, Color, CommonProperties } from '../../styles';
import Slide from './Slide';
import TabBar from '../SegmentedControl/TabBar';
import PNRInfo from './PNRInfo';
import PassengerInfo from './PassengerInfo';
import Images from '../../constants/Images';
import BaseText from '../BaseText';
import { useNavigation } from '@react-navigation/native';
import { Screens, Modals } from '../../constants/ScreenNames';
import Bar from '../SegmentedControl/Bar';
import useAvailableHeight from '../../utils/useAvailableHeight';
import { scale } from '../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';
import {
  REBOOK_ENABLED,
  TRIPHUB_ENABLED,
  TRIPEVENTS_ENABLED,
  EVENTS_ENABLED,
  EXPENSEPOINT_ENABLED,
  CREW_ENABLED,
} from '../../config/env';
import { tripsFilter, searchTypesEnum } from '../../constants/Enums';
import moment from 'moment';
import { selectReceiptSortedElements } from '../../store/selectors/mytrips.selector';
import { useSelector } from 'react-redux';

const ROOMS = 'ROOMS';
const DIRECTIONS = 'DIRECTIONS';
const RIDESHARE = 'RIDESHARE';
const ADD_REVIEW = 'ADD_REVIEW';
const { UPCOMING_PURCHASE, TRAVELED } = tripsFilter;
const { HOTEL } = searchTypesEnum;

const HotelPage = ({ hotel, passengers, tripStatus, TripKey }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('HotelPage');
  const navigation = useNavigation();
  const availableHeight = useAvailableHeight(scale(150));
  const { HotelName, AddressLine1, CheckInDateText, CheckOutDateText, HotelId } = hotel;
  const currentDate = moment();
  const checkInDate = moment(CheckInDateText, 'MMMM DD, YYYY');
  const sortedElements = useSelector(selectReceiptSortedElements);
  const currentHotel = sortedElements?.find((element) => {
    return element.cardType === HOTEL && element.HotelId === hotel.HotelId;
  });
  /**
   * obtaining HotelReview from sortedElements because hotel.HotelReview is not reflecting the new value
   * when the HotelReview is inserted or updated to the redux due to some re-rendering issue
   */
  const HotelReview = currentHotel?.HotelReview;
  const IsHotelReviewInDB = HotelReview != null;

  const hotelTabItems = [
    //{ icon: 'room', second: 'Rooms', value: ROOMS },
    { icon: 'gps', label: t(tKey('DIRECTIONS')), value: DIRECTIONS },
  ];

  if (
    TRIPHUB_ENABLED ||
    REBOOK_ENABLED ||
    TRIPEVENTS_ENABLED ||
    EVENTS_ENABLED ||
    EXPENSEPOINT_ENABLED
  ) {
    hotelTabItems.push({ icon: 'car', label: t(tKey('RIDESHARE')), value: RIDESHARE });
  } else {
    if (
      (tripStatus === UPCOMING_PURCHASE || tripStatus === TRAVELED) &&
      currentDate.isSameOrAfter(checkInDate, 'day')
    ) {
      if (!CREW_ENABLED) {
        hotelTabItems.push({ icon: 'car', label: t(tKey('RIDESHARE')), value: RIDESHARE });
      }
      const label = IsHotelReviewInDB ? 'Edit Review' : 'Add Review';
      hotelTabItems.push({ icon: 'star', label, value: ADD_REVIEW });
    }
  }

  const onChange = (value) => {
    switch (value) {
      case ROOMS:
        navigation.navigate(Screens.Rooms);
        break;
      case DIRECTIONS:
        navigation.navigate(Modals.DirectionModal, { page: 'hotel' });
        break;
      case RIDESHARE:
        navigation.navigate(Modals.RideShareModal, { page: 'hotel' });
        break;
      case ADD_REVIEW:
        navigation.navigate(Modals.AddReviewModal, {
          HotelName,
          AddressLine1,
          CheckInDateText,
          CheckOutDateText,
          HotelId,
          TripKey,
          HotelReview,
          IsHotelReviewInDB,
        });
        break;
    }
  };

  return (
    <ScrollView>
      <View style={{ height: availableHeight, backgroundColor: 'white' }}>
        <Slide
          image={
            hotel.HotelCode
              ? Images.hotel['24x24'][hotel.HotelCode]
              : Images.hotel['24x24']['other']
          }
          name={hotel.HotelName}
          detail={hotel.AddressLine1}
          startLabel={t(tKey('CheckIn'))}
          startTime={hotel.CheckInTime || '--'}
          startDetail={hotel.CheckInDateText}
          endLabel={t(tKey('CheckOut'))}
          endTime={hotel.CheckOutTime || '--'}
          endDetail={hotel.CheckOutDateText}
        >
          <BaseText>12mi from Airport</BaseText>
        </Slide>
        <Bar
          items={hotelTabItems}
          onChange={(value) => {
            onChange(value, hotel);
          }}
          style={styles.tabBar}
        />
        <PNRInfo
          style={CommonStyles.mb3}
          label={t(tKey('HotelReservation'))}
          value={hotel.HotelConfirmationNumber}
        />
        {passengers && passengers.length > 0
          ? passengers.map((passenger, index) => (
              <PassengerInfo
                key={index}
                label={t(tKey('CheckinName'))}
                value={passenger.FirstName + ' ' + passenger.LastName}
              />
            ))
          : null}
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  tabBar: {
    borderTopWidth: 0.01,
    borderTopColor: 'rgba(0,0,0,.1)',
    ...CommonProperties.py5,
  },
});

export default HotelPage;
